<template>
	<p class="mb-2 text-base leading-[1.2]">{{ $t("landingPage.subheadline") }}</p>
	<h1 class="mb-4 text-2xl font-semibold leading-[1.2]">{{ store.landingPage.headerText }}</h1>
</template>

<script setup lang="ts">
import { store } from "@/state/store";
import { $t } from "@/main";

if (store.landingPage.headerText === "") {
	store.landingPage.headerText = $t("landingPage.headline");
}
</script>
